module.exports = __webpack_public_path__ + "img/friendline01-top.cf67c36a.jpg";